import Vue from 'vue'
import Router from 'vue-router'

import setTitle from '../utils/setTitle'
import * as baseMethods from '../utils/baseMethod'
import {Axios} from '../utils/Axios'
import store from '../store/index'
import { customerUsers } from '@/services/api.index'
import { Loading } from 'element-ui'

import Index from '@/views/index'
import Compose from '@/views/tec/compose'
import Compose1 from '@/views/tec/compose_1'
import Compose2 from '@/views/tec/compose_2'
import Compose3 from '@/views/tec/compose_3'
import GenCompose from '@/views/tec/gen_compose'
import Sanger from '@/views/tec/sanger'
import Summary from '@/views/summary/index'
import SummaryAbout from '@/views/summary/about'
import SummaryDevelop from '@/views/summary/develop'
import SummaryGlobal from '@/views/summary/global'
import SummaryAchievement from '@/views/summary/achievement'
import SummaryContact from '@/views/summary/contact'
import News from '@/views/news/index'
import News1 from '@/views/news/index1'
import NewsDetails from '@/views/news/details'
import NewsMarket from '@/views/news/market'
import NewsDetails1 from '@/views/news/details1'
import Resource from '@/views/resource/index'
import TsingMap from '@/views/TsingMap/index'
import SummaryJoinUs from '@/views/summary/join_us'
import Recruit from '@/views/recruit'
import QPCR from '@/views/tec/qPCR.vue'
import RDNA from '@/views/tec/rDNA.vue'
import SNP from '@/views/tec/SNP.vue'
import SSR from '@/views/tec/SSR.vue'
import Specific from '@/views/tec/specific.vue'
import Extraction from '@/views/tec/extraction.vue'
import CellFree from '@/views/tec/cell_free.vue'
import Identification from '@/views/tec/identification.vue'
import Vector from '@/views/tec/vector.vue'
import DNAExtraction from '@/views/tec/DNA_extraction.vue'
import DNABarcode from '@/views/tec/DNA_barcode.vue'
import PCR from '@/views/tec/PCR.vue'
import ITS from '@/views/tec/ITS.vue'
import Mitochondrial from '@/views/tec/mitochondrial.vue'
import Whole_plasmid from '@/views/tec/Whole_plasmid.vue'
import Amplicon from '@/views/tec/amplicon.vue'
import Prokaryotic from '@/views/tec/prokaryotic.vue'
import Eukaryotic from '@/views/tec/eukaryotic.vue'
import Fungal from '@/views/tec/fungal.vue'
import Resequencing from '@/views/tec/resequencing.vue'
import CircRNA from '@/views/tec/circRNA.vue'
import IncRNA from '@/views/tec/incRNA.vue'
import SmallRNA from '@/views/tec/smallRNA.vue'
import Macrogenome from '@/views/tec/macrogenome.vue'
import TargetSequencing from '@/views/tec/target_sequencing.vue'
import HumanSequencing from '@/views/tec/human_sequencing.vue'
import DeNovo from '@/views/tec/de_novo.vue'
import FullLength from '@/views/tec/full_length.vue'
import WholeTransciptome from '@/views/tec/whole_transciptome.vue'
import WholeExome from '@/views/tec/whole_exome.vue'
import Bacterial from '@/views/tec/bacterial.vue'
import T15KL from '@/views/intel/T15KL.vue'
import Wh5 from '@/views/intel/wh5.vue'
import Mp2500 from '@/views/intel/mp2500.vue'
import Mc15k from '@/views/intel/mc15k.vue'
import Compose12 from '@/views/intel/compose12.vue'
import Compose192 from '@/views/intel/compose192.vue'
import Compose768 from '@/views/intel/compose768.vue'
import Tm30 from '@/views/intel/tm30.vue'
import Device1 from '@/views/intel/device_1.vue'
import Device2 from '@/views/intel/device_2.vue'
import Device3 from '@/views/intel/device_3.vue'
import Am096 from '@/views/intel/am096.vue'
import AKTA from '@/views/intel/AKTA.vue'
import R01 from '@/views/intel/R01.vue'
import Mini7ks from '@/views/intel/mini_7ks.vue'
import RT20 from '@/views/intel/RT20.vue'
import Metal from '@/views/intel/metal.vue'
import MIX2500 from '@/views/intel/MIX2500.vue'
import MiniCentrifuge from '@/views/intel/mini_centrifuge.vue'
import Products from '@/views/products/index.vue'
import ProductsDetails from '@/views/products/details.vue'
import Search from '@/views/search.vue'
import Login from '@/views/login.vue'
import Register from '@/views/register.vue'
import Reset from '@/views/reset.vue'
import Forget from '@/views/forget.vue'
import AccountStatus from '@/views/account_status.vue'
import OrderSanger from '@/views/tec/order_sanger.vue'
import OrderPrimer from '@/views/tec/order_primer.vue'
import PrimerConfirm from '@/views/tec/primer_confirm.vue'
import OrderGene from '@/views/tec/order_gene.vue'
import GeneConfirm from '@/views/tec/gene_confirm.vue'
import SuccessSubmit from '@/views/tec/success_submit.vue'
import ProductsChart from '@/views/products/chart.vue'
import ProductsChartConfirm from '@/views/products/chart_confirm.vue'
import User from '@/views/user/index.vue'
import UserIndex from '@/views/user/children/index.vue'
import UserCourse from '@/views/user/children/course.vue'
import UserMolecular from '@/views/user/children/molecular.vue'
import UserSanger from '@/views/user/children/sanger.vue'
import fastNGS from '@/views/user/children/fastNGS.vue'
import UserSangerRecord from '@/views/user/children/sanger_record.vue'
import UserPrimer from '@/views/user/children/primer.vue'
import UserGene from '@/views/user/children/gene.vue'
import UserProject from '@/views/user/children/project.vue'
import UserMall from '@/views/user/children/mall.vue'
import UserIntegralGet from '@/views/user/children/integral_get.vue'
import UserIntegralExchange from '@/views/user/children/integral_exchange.vue'
import UserProductDetail from '@/views/user/product_details.vue'
import OrderIntergal from '@/views/user/order_intergal.vue'
import UserProjectDetails from '@/views/user/project_details.vue'
import UserSangerDetails from '@/views/user/sanger_details.vue'
import fastNGSDetails from '@/views/user/fastNGS_details.vue'
import UserMolecularDetails from '@/views/user/molecular_details.vue'
import UserSangerSearch from '@/views/user/sanger_search.vue'
import UserCollection from '@/views/user/Collection_details.vue'
import UserComment from '@/views/user/comment_details.vue'
import UserConsult from '@/views/user/consult_details.vue'
import arrivalNotice from '@/views/user/arrivalNotice.vue'
import UserPrimerDetails from '@/views/user/primer_details.vue'
import UserGeneDetails from '@/views/user/gene_details.vue'
import download from '@/views/download.vue'
//新版页面新增路由
import UserPrimerSearch from '@/views/user/primer_search.vue'
import Conventional_molecular_project from '@/views/products/Conventional_molecular_project'
import Fixed from '@/views/products/Fixed-mutation'
import PCR1 from '@/views/products/PCR_cloning'
import Plasmid from '@/views/products/Plasmid_Extraction'
import subclone from '@/views/products/subclone'
import Products1 from '@/views/products/Products1'
import Products2 from '@/views/products/Products2'
import Gene from '@/views/products/Gene'
import Gene_regulation from '@/views/products/Gene_regulation'
import Gene_editing from '@/views/products/Gene_editing'
import Gene_interference from '@/views/products/Gene_interference'
import Gene_SNP from '@/views/products/Gene_SNP'
import Methylation_detection from '@/views/products/Methylation_detection'
import Protein_expression from '@/views/products/Protein_expression'
import Virus_packaging from '@/views/Virus/Virus_packaging.vue'
import Lentivirus_packaging from '@/views/Virus/Lentivirus_packaging.vue'
import Adenovirus_packaging from '@/views/Virus/Adenovirus_packaging.vue'
import Adeno_associated_virus from '@/views/Virus/Adeno_associated_virus.vue'
import life_sciences from '@/views/equipment/life_sciences.vue'
import Biological from '@/views/Biological_manufacturing/Biological.vue'
import GeneFactory from '@/views/gene-factory'
import generation_sequencing from '@/views/tec/1.5_generation_sequencing.vue'
import Genome_sequencing from '@/views/products/Genome_sequencing.vue'
import Microbial_sequencing from '@/views/products/Microbial_sequencing.vue'
import Transcriptome_sequencing from '@/views/products/Transcriptome_sequencing.vue'
import Chemical_Reagents from '@/views/equipment/Chemical_Reagents.vue'
import Instruments_equipment from '@/views/equipment/Instruments_equipment.vue'
import IntegratedScheme from '@/views/equipment/IntegratedScheme.vue'
import Modified_synthesis from '@/views/equipment/Modified_synthesis.vue'
import Molecular_reagent from '@/views/molecular_reagents/Molecular_reagent.vue'
import DNA_tiqu from '@/views/products/DNA_tiqu.vue'
import Tvector_cloning from  '@/views/products/Tvector_cloning.vue'
import BSP_Sequencing from  '@/views/products/BSP_Sequencing.vue'
import Plant from '@/views/tec/Plant_animal_resequencing.vue'
import Viral from '@/views/tec/Viral_genome_sequencing.vue'
import sgRNA from '@/views/products/sgRNA_Synthesis.vue'
import shRNA_lentiviral from '@/views/products/shRNA_lentiviral.vue'
import siRNA_miRNA_synthesis from '@/views/products/siRNA_miRNA_synthesis.vue'
import shRNA_library from '@/views/products/shRNA_library_construction.vue'
import circRNA from '@/views/products/circRNA_overexpression.vue'
import ASO from '@/views/products/ASO_antisense.vue'
import sgRNA_plasmid_construction from '@/views/products/sgRNA_plasmid_construction.vue'
import sgRNA_library_construction from '@/views/products/sgRNA_library_construction.vue'
import Cas9_sgRNA_library_construction from "../views/products/Cas9_sgRNA_library_construction"
import CRISPRi_CRISPRa_Applications from '@/views/products/CRISPRi_CRISPRa_Applications.vue'
import RecombinantCellsProteinExpression from '@/views/products/recombinant-cells-protein-expression'
import mycoupon from '@/views/user/children/My_Coupons.vue'
import bind from '@/views/user/children/Binding_Coupons.vue'
// 分享外联页面引入,无跳转
import MemberAuth from '@/views/share/member-auth'
import ConfirmOrder from '@/views/share/confirm-order'
import ConfirmPopup from '@/views/share/confirm-popup'


// import MIndex from '@/views/mobile/index'
// import MBind from '@/views/mobile/bind'
// import MAccountStatus from '@/views/mobile/account_status'
import mobileRoutes from './mobile'
import {loginShopDelete} from '../services/api.index'
import * as baseMthods from "../utils/baseMethod";
// let commonIndex = Index
// let commonLogin = Login
// let commonAccountStatus = AccountStatus
// eslint-disable-next-line no-unused-vars
let isMobile = false
if (navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)) {
  isMobile = true
  // commonIndex = MIndex
  // commonLogin = MBind
  // commonAccountStatus = MAccountStatus
}

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '擎科生物',
      requireAuth: true,
      content: {
        keywords: '测序 引物  基因合成 分子试剂',
        description: '推动生物科技发展，让世界更美好'
      }
    }
  },
  {
    path: '/summary',
    component: Summary,
    meta: {
      title: '擎科概况'
    },
    children: [{
      path: '/summary/about',
      name: 'SummaryAbout',
      component: SummaryAbout,
      meta: {
        title: '擎科简介',
        content: {
          keywords:'合成生物学 基因  引物 测序',
          description:'擎科生物是一家CXO的公司'
        }
      }
    },
    //  {
    //   path: '/summary/develop',
    //   name: 'SummaryDevelop',
    //   component: SummaryDevelop,
    //   meta: {
    //     title: '发展历程'
    //   }
    // }, 
    {
      path: '/summary/global',
      name: 'SummaryGlobal',
      component: SummaryGlobal,
      meta: {
        title: '全国布局'
      }
    }, {
      path: '/summary/achievement',
      name: 'SummaryAchievement',
      component: SummaryAchievement,
      meta: {
        title: '发展成果'
      }
    }, {
      path: '/summary/contact',
      name: 'SummaryContact',
      component: SummaryContact,
      meta: {
        title: '联系我们'
      }
    }]
  }, {
    path: '/news',
    component: News,
    meta: {
      title: '擎科新闻'
    }
  }, {
    path: '/news/index1',
    component: News1,
    meta: {
      title: '市场活动'
    }
  },{
    path: '/news/details/:id',
    name: 'NewsDetails',
    component: NewsDetails,
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/products/Products1',
    name: 'Products1',
    component: Products1,
    meta: {
      title: '产品及服务'
    },
    children: [
      {
        path: '/equipment/Chemical_Reagents',
        name: 'Chemical_Reagents',
        component: Chemical_Reagents,
        meta: {
          show:true,
          title: '化学试剂'
        }
      },
      {
        path: '/equipment/IntegratedScheme',
        name: 'IntegratedScheme',
        component: IntegratedScheme,
        meta: {
          show:true,
          title: '合成原料/设备/工艺 一站式解决方案'
        }
      },
      {
        path: '/equipment/Modified_synthesis',
        name: 'Modified_synthesis',
        component: Modified_synthesis,
        meta: {
          show:true,
          title: '寡核苷酸修饰'
        },
        children: [
          {
            path: '/tec/compose1',
            name: 'Compose1',
            component: Compose1,
            meta: {
              invisible:true,
              title: 'DNA合成'
            }
          },
          {
            path: '/tec/compose3',
            name: 'Compose3',
            component: Compose3,
            meta: {
              invisible:true,
              title: 'RNA合成'
            },
            children: []
          },
        ]
      },
      {
        path: '/tec/compose',
        name: 'Compose',
        component: Compose,
        meta: {
          show:true,
          title: '寡核苷酸合成',
          content: {
            keywords: '引物 快速 24小时 全国',
            description: '18个基地的引物合成'
          }
        },children: [
          {
            path: '/tec/compose2',
            name: 'Compose2',
            component: Compose2,
            meta: {
              invisible:true,
              title: '修饰引物/探针合成'
            },
            children: []
          },
        ]
      },
      {
        path: '/products/Products2',
        name: 'Products2',
        component: Products2,
        meta: {
          show:true,
          title: '基因合成',
        },children: [
          {
            path: '/tec/gen_compose',
            name: 'GenCompose',
            component: GenCompose,
            meta: {
              invisible:true,
              title: '基因合成'
            }
          },
          {
            path: '/products/Fixed-mutation',
            name: 'Fixed',
            component: Fixed,
            meta: {
              invisible:true,
              title: '定点突变'
            }
          },
          {
            path: '/products/PCR_cloning',
            name: 'PCR1',
            component: PCR1,
            meta: {
              invisible:true,
              title: 'PCR克隆'
            }
          },
          {
            path: '/products/Plasmid_Extraction',
            name: 'Plasmid',
            component: Plasmid,
            meta: {
              invisible:true,
              title: '质粒抽提'
            }
          },
          {
            path: '/products/subclone',
            name: 'subclone',
            component: subclone,
            meta: {
              invisible:true,
              title: '亚克隆'
            }
          },
        ]
      },

      {
        path: '/products/Conventional_molecular_project',
        name: 'Conventional_molecular_project',
        component: Conventional_molecular_project,
        alwaysShow: false,
        meta: {
          show:true,
          title: '其他服务项目'
        },
        children: [
          {
            path: '/tec/DNA_extraction',
            name: 'DNAExtraction',
            component: DNAExtraction,
            meta: {
              invisible:true,
              title: 'DNA提取'
            }
          },
          {
            path: '/tec/PCR',
            name: 'PCR',
            component: PCR,
            meta: {
              invisible:true,
              title: 'PCR扩增'
            }
          },
          {
            path: '/tec/SSR',
            name: 'SSR',
            component: SSR,
            meta: {
              invisible:true,
              title: 'SSR/STR检测'
            }
          },
          {
            path: '/tec/SNP',
            name: 'SNP',
            component: SNP,
            meta: {
              invisible:true,
              title: 'SNP检测'
            }
          },
          {
            path: '/products/DNA_tiqu',
            name: 'DNA_tiqu',
            component: DNA_tiqu,
            meta: {
              invisible:true,
              title: '提取+扩增+测序'
            }
          },
          {
            path: '/products/Tvector_cloning',
            name: 'Tvector_cloning',
            component: Tvector_cloning,
            meta: {
              invisible:true,
              title: 'T 载体克隆'
            }
          },
          {
            path: '/products/BSP_Sequencing',
            name: 'BSP_Sequencing',
            component: BSP_Sequencing,
            meta: {
              invisible:true,
              title: '甲基化检测（BSP测序）'
            }
          },
          {
            path: '/tec/specific',
            name: 'Specific',
            component: Specific,
            meta: {
              invisible:true,
              title: '特定基因检测'
            }
          },
          {
            path: '/tec/qPCR',
            name: 'QPCR',
            component: QPCR,
            meta: {
              invisible:true,
              title: '荧光定量PCR'
            }
          },
          {
            path: '/tec/rDNA',
            name: 'RDNA',
            component: RDNA,
            meta: {
              invisible:true,
              title: '菌种鉴定'
            }
          },
          {
            path: '/tec/identification',
            name: 'Identification',
            component: Identification,
            meta: {
              invisible:true,
              title: '细胞系鉴定'
            }
          },
        ]
      },
      {
        path: '/Virus/Virus_packaging',
        name: 'Virus_packaging',
        component: Virus_packaging,
        meta: {
          show:true,
          title: '病毒包装'
        },
        children: [
          {
            path: '/Virus/Lentivirus_packaging',
            name: 'Lentivirus_packaging',
            component: Lentivirus_packaging,
            meta: {
              invisible:true,
              title: '慢病毒包装'
            },
          },{
            path: '/Virus/Adenovirus_packaging',
            name: 'Adenovirus_packaging',
            component: Adenovirus_packaging,
            meta: {
              invisible:true,
              title: '腺病毒包装'
            },
          },{
            path: '/Virus/Adeno_associated_virus',
            name: 'Adeno_associated_virus',
            component: Adeno_associated_virus,
            meta: {
              invisible:true,
              title: '腺相关病毒'
            },
          },
        ]
      },
      {
        path: '/products/Gene',
        name: 'Gene',
        component: Gene,
        meta: {
          show:true,
          title: '基因检测'
        },
        children: [
          {
            path: '/sanger',
            name: 'Sanger',
            component: Sanger,
            meta: {
              invisible:true,
              title: 'Sanger测序',
              content: {
                keywords: '测序 快速 24小时 全国',
                description: '打造中国测序民族品牌'
              }
            },
            children:[]
          },
          {
            path: '/products/Genome_sequencing',
            name: 'Genome_sequencing',
            component: Genome_sequencing,
            meta: {
              invisible:true,
              title: '基因组测序'
            },
            children: [
              {
                path: '/tec/human_sequencing',
                name: 'HumanSequencing',
                component: HumanSequencing,
                meta: {
                  invisibles:true,
                  title: '人全基因组测序'
                }
              },
              {
                path: '/tec/whole_exome',
                name: 'WholeExome',
                component: WholeExome,
                meta: {
                  invisibles:true,
                  title: '人全外显子组测序'
                }
              },
              {
                path: '/tec/Plant_animal_resequencing',
                name: 'Plant',
                component: Plant,
                meta: {
                  invisibles:true,
                  title: '动植物重测序'
                }
              },
              {
                path: '/tec/mitochondrial',
                name: 'Mitochondrial',
                component: Mitochondrial,
                meta: {
                  invisibles:true,
                  title: '线粒体/叶绿体精细图测序'
                }
              },
              {
                path: '/tec/Viral_genome_sequencing',
                name: 'Viral',
                component: Viral,
                meta: {
                  invisibles:true,
                  title: '病毒基因组测序'
                }
              },
            ]
          },
          {
            path: '/products/Transcriptome_sequencing',
            name: 'Transcriptome_sequencing',
            component: Transcriptome_sequencing,
            meta: {
              invisible:true,
              title: '转录组测序'
            },
            children: [
              {
                path: '/tec/whole_transciptome',
                name: 'WholeTransciptome',
                component: WholeTransciptome,
                meta: {
                  invisibles:true,
                  title: '全转录组测序'
                }
              },
              {
                path: '/tec/prokaryotic',
                name: 'Prokaryotic',
                component: Prokaryotic,
                meta: {
                  invisibles:true,
                  title: '原核转录组测序'
                }
              },
              {
                path: '/tec/eukaryotic',
                name: 'Eukaryotic',
                component: Eukaryotic,
                meta: {
                  invisibles:true,
                  title: '真核转录组测序'
                }
              },
              {
                path: '/tec/full_length',
                name: 'FullLength',
                component: FullLength,
                meta: {
                  invisibles:true,
                  title: '全长转录组测序'
                }
              },
              {
                path: '/tec/incRNA',
                name: 'IncRNA',
                component: IncRNA,
                meta: {
                  invisibles:true,
                  title: 'IncRNA测序'
                }
              },
              {
                path: '/tec/smallRNA',
                name: 'SmallRNA',
                component: SmallRNA,
                meta: {
                  invisibles:true,
                  title: 'small RNA测序'
                }
              },
            ]
          },
          {
            path: '/products/Microbial_sequencing',
            name: 'Microbial_sequencing',
            component: Microbial_sequencing,
            meta: {
              invisible:true,
              title: '微生物测序'
            },
            children: [
              {
                path: '/tec/ITS',
                name: 'ITS',
                component: ITS,
                meta: {
                  invisibles:true,
                  title: '16S/18S/ITS扩增子测序(二代)'
                }
              },
              {
                path: '/tec/amplicon',
                name: 'Amplicon',
                component: Amplicon,
                meta: {
                  invisibles:true,
                  title: '16S/18S/ITS扩增子测序(三代)'
                }
              },
              {
                path: '/tec/bacterial',
                name: 'Bacterial',
                component: Bacterial,
                meta: {
                  invisibles:true,
                  title: '细菌基因组测序'
                }
              },
              {
                path: '/tec/fungal',
                name: 'Fungal',
                component: Fungal,
                meta: {
                  invisibles:true,
                  title: '真菌基因组测序'
                }
              },
              {
                path: '/tec/macrogenome',
                name: 'Macrogenome',
                component: Macrogenome,
                meta: {
                  invisibles:true,
                  title: '宏基因组测序'
                }
              },
            ]
          },
          {
            path: '/tec/1.5_generation_sequencing',
            name: '1.5_generation_sequencing',
            component: generation_sequencing,
            meta: {
              invisible:true,
              title: 'Fast NGS'
            },
            children: []
          },

        ]
      },
      {
        path: '/products/Gene_regulation',
        name: 'Gene_regulation',
        component: Gene_regulation,
        meta: {
          show: true,
          title: '基因调控'
        },
        children: [
          {
            path: '/products/Gene_editing',
            name: 'Gene_editing',
            component: Gene_editing,
            meta: {
              invisible:true,
              title: '基因编辑'
            },
            children: [
              {
                path: '/products/sgRNA_Synthesis',
                name: 'sgRNA_Synthesis',
                component: sgRNA,
                meta: {
                  invisibles:true,
                  title: 'sgRNA合成'
                }
              },
              {
                path: '/products/sgRNA_plasmid_construction',
                name: 'sgRNA_plasmid_construction',
                component: sgRNA_plasmid_construction,
                meta: {
                  invisibles:true,
                  title: 'sgRNA质粒构建'
                }
              },
              {
                path: '/products/sgRNA_library_construction',
                name: 'sgRNA_library_construction',
                component: sgRNA_library_construction,
                meta: {
                  invisibles:true,
                  title: 'sgRNA文库构建'
                }
              },
              {
                path: '/products/Cas9_sgRNA_library_construction',
                name: 'Cas9_sgRNA_library_construction',
                component: Cas9_sgRNA_library_construction,
                meta: {
                  invisibles:true,
                  title: 'Cas9 sgRNA文库构建服务'
                }
              },
              {
                path: '/products/CRISPRi_CRISPRa_Applications',
                name: 'CRISPRi_CRISPRa_Applications',
                component: CRISPRi_CRISPRa_Applications,
                meta: {
                  invisibles:true,
                  title: 'CRISPRa/CRISPRi应用'
                }
              },
            ]
          },
          {
            path: '/products/Gene_interference',
            name: 'Gene_interference',
            component: Gene_interference,
            meta: {
              invisible:true,
              title: '基因干扰'
            },
            children: [
              {
                path: '/products/shRNA_lentiviral',
                name: 'shRNA_lentiviral',
                component: shRNA_lentiviral,
                meta: {
                  invisibles:true,
                  title: 'shRNA慢病毒质粒构建'
                }
              },
              {
                path: '/products/siRNA_miRNA_synthesis',
                name: 'shRNA_lentiviral',
                component: siRNA_miRNA_synthesis,
                meta: {
                  invisibles:true,
                  title: 'siRNA/miRNA合成'
                }
              },
              {
                path: '/products/shRNA_library_construction',
                name: 'shRNA_library_construction',
                component: shRNA_library,
                meta: {
                  invisibles:true,
                  title: 'shRNA文库构建'
                }
              },
            ]
          },
          {
            path: '/products/ASO_antisense',
            name: 'ASO_antisense',
            component: ASO,
            meta: {
              invisibles:true,
              title: 'ASO反义寡核苷酸'
            }
          },

          {
            path: '/products/circRNA_overexpression',
            name: 'circRNA_overexpression',
            component: circRNA,
            meta: {
              invisible:true,
              title: 'circRNA过表达质粒构建'
            }
          },


          {
            path: '/products/Methylation_detection',
            name: 'Methylation_detection',
            component: Methylation_detection,
            meta: {
              invisible:true,
              title: '甲基化检测'
            }
          },
          // {
          //   path: '/products/Gene_SNP',
          //   name: 'Gene_SNP',
          //   component: Gene_SNP,
          //   meta: {
          //     invisible:true,
          //     title: '基因Pannel定制及SNP分型'
          //   }
          // },
          {
            path: '/products/Protein_expression',
            name: 'Protein_expression',
            component: Protein_expression,
            meta: {
              invisible:true,
              title: '蛋白表达'
            }
          },
        ]
      },
      {
        path: '/products/recombinant-cells-protein-expression',
        name: 'RecombinantCellsProteinExpression',
        component: RecombinantCellsProteinExpression,
        meta: {
          show: true,
          title: '快速重组细胞及蛋白表达'
        }
      }
    ]
  },
  {
    path: '/molecular-reagent',
    name: 'molecular_reagent_single',
    component: Molecular_reagent,
    meta: {
      show: false,
      title: '分子试剂',
      scrollTop: false
    }
  },
  {
    path: '/equipment/Instruments_equipment',
    name: 'Instruments_equipment',
    component: Instruments_equipment,
    meta: {
      show:true,
      title: '合成设备'
    },
    children: [
      {
        path: '/intel/device_1',
        name: 'Device1',
        component: Device1,
        meta: {
          invisible:true,
          title: '合成仪'
        },
        children: [
          {
            path: '/intel/compose12',
            name: 'Compose12',
            component: Compose12,
            meta: {
              invisibles:true,
              title: '合成仪-12通道'
            }
          }, {
            path: '/intel/compose192',
            name: 'Compose192',
            component: Compose192,
            meta: {
              invisibles:true,
              title: '合成仪-192通道',
              content: {
                keywords: '192通道合成仪  768通道合成仪',
                description: '自主研发的DNA合成仪'
              }
            }
          }, {
            path: '/intel/compose768',
            name: 'Compose768',
            component: Compose768,
            meta: {
              invisibles:true,
              title: '合成仪-768通道',
              content: {
                keywords: '192通道合成仪  768通道合成仪',
                description: '自主研发的DNA合成仪'
              }
            }
          },
        ]
      },
      {
        path: '/intel/device_2',
        name: 'Device2',
        component: Device2,
        meta: {
          invisible:true,
          title: '合成配套设备'
        },
        children: [
          {
            path: '/intel/am096',
            name: 'Am096',
            component: Am096,
            meta: {
              invisibles:true,
              title: '氨解仪'
            }
          },
          {
            path: '/intel/AKTA',
            name: 'AKTA',
            component: AKTA,
            meta: {
              invisibles:true,
              title: '纯化仪'
            }
          }, {

            path: '/intel/R01',
            name: 'R01',
            component: R01,
            meta: {
              invisibles:true,
              title: '溶解仪'
            }
          },
        ]
      },
      {
        path: '/intel/device_3',
        name: 'Device3',
        component: Device3,
        meta: {
          invisible:true,
          title: '小型实验设备'
        }
      },
    ]
  },
  {
    path: '/equipment/life_sciences',
    name: 'life_sciences',
    component: life_sciences,
    meta: {
      title: '生命科学研究设备及原料'
    },
    children: [
      // {
      //   path: '/equipment/Modified_synthesis',
      //   name: 'Modified_synthesis',
      //   component: Modified_synthesis,
      //   meta: {
      //     show:true,
      //     title: '修饰合成'
      //   },
      //   children: [
      //     {
      //       path: '/tec/compose2',
      //       name: 'Compose2',
      //       component: Compose2,
      //       meta: {
      //         invisible:true,
      //         title: '修饰引物/探针合成'
      //       },
      //       children: []
      //     },
      //     {
      //       path: '/tec/compose3',
      //       name: 'Compose3',
      //       component: Compose3,
      //       meta: {
      //         invisible:true,
      //         title: 'RNA合成'
      //       },
      //       children: []
      //     },
      //   ]
      // },
      
      {
        path: '/equipment/Molecular_reagent',
        name: 'Molecular_reagent',
        component: Molecular_reagent,
        meta: {
          show: false,
          title: '分子试剂',
          scrollTop: true
        },
        children: [
          {
            path: '/products/details/:id',
            name: 'ProductsDetails',
            component: ProductsDetails,
            meta: {
              invisible:true,
              title: '分子试剂详情'
            }
          },
        ]
      },
      // {
      //   path: '/equipment/Chemical_Reagents',
      //   name: 'Chemical_Reagents',
      //   component: Chemical_Reagents,
      //   meta: {
      //     show:true,
      //     title: '化学试剂'
      //   }
      // },
      // {
      //   path: '/equipment/IntegratedScheme',
      //   name: 'IntegratedScheme',
      //   component: IntegratedScheme,
      //   meta: {
      //     show:true,
      //     title: '合成原料/设备/工艺 一站式解决方案'
      //   }
      // },

    ]
  },
  {
    path: '/Biological_manufacturing/Biological',
    name: 'Biological',
    component: Biological,
    meta: {
      title: '生物制造CXO'
    }
  },
  {
    path: '/gene-factory',
    name: 'GeneFactory',
    component: GeneFactory,
    meta: {
      title: '基因工厂'
    }
  },
  {
    path: '/market',
    name: 'NewsMarket',
    component: NewsMarket,
    meta: {
      title: '营销内容'
    }
  },
  {
    path: '/news/details1/:id',
    name: 'NewsDetails1',
    component: NewsDetails1,
    meta: {
      title: '营销内容详情'
    }
  },{
    path: '/resource',
    component: Resource,
    meta: {
      title: '资源中心'
    }
  },{
    path: '/TsingMap',
    component: TsingMap,
    meta: {
      title: '站点地图'
    }
  }, {
    path: '/summary/join_us',
    name: 'SummaryJoinUs',
    component: SummaryJoinUs,
    meta: {
      title: '加入擎科'
    }
  }, {
    path: '/recruit',
    name: 'Recruit',
    component: Recruit,
    meta: {
      title: '招聘详情'
    }
  },     {
    path: '/tec/extraction',
    name: 'Extraction',
    component: Extraction,
    meta: {
      title: '提取扩增测序'
    }
  }, {
    path: '/tec/cell_free',
    name: 'CellFree',
    component: CellFree,
    meta: {
      title: '无细胞蛋白合成系统'
    }
  },  {
    path: '/tec/vector',
    name: 'Vector',
    component: Vector,
    meta: {
      title: '载体构建'
    }
  },  {
    path: '/tec/DNA_barcode',
    name: 'DNABarcode',
    component: DNABarcode,
    meta: {
      title: 'DNA条码检测'
    }
  },   {
    path: '/tec/resequencing',
    name: 'Resequencing',
    component: Resequencing,
    meta: {
      title: '重测序'
    }
  }, {
    path: '/tec/circRNA',
    name: 'CircRNA',
    component: CircRNA,
    meta: {
      title: 'circRNA测序'
    }
  },    {
    path: '/tec/target_sequencing',
    name: 'TargetSequencing',
    component: TargetSequencing,
    meta: {
      title: '目标区域测序'
    }
  },  {
    path: '/tec/de_novo',
    name: 'DeNovo',
    component: DeNovo,
    meta: {
      title: '全基因组de novo测序'
    }
  },
     {
    path: '/intel/T15KL',
    name: 'T15KL',
    component: T15KL,
    meta: {
      title: 'T15KL手持式无线均质仪'
    }
  }, {
    path: '/intel/wh5',
    name: 'Wh5',
    component: Wh5,
    meta: {
      title: 'WH-5 / WH-10水浴锅'
    }
  }, {
    path: '/intel/mp2500',
    name: 'Mp2500',
    component: Mp2500,
    meta: {
      title: 'MP-2500微孔板离心机'
    }
  }, {
    path: '/intel/mc15k',
    name: 'Mc15k',
    component: Mc15k,
    meta: {
      title: 'MC-15K微型高速离心机'
    }
  },  {
    path: '/intel/tm30',
    name: 'Tm30',
    component: Tm30,
    meta: {
      title: 'TM-30转盘混合仪'
    }
  },
    {
    path: '/intel/mini_7ks',
    name: 'Mini7ks',
    component: Mini7ks,
    meta: {
      title: 'Mini-7KS复合转子离心机 '
    }
  }, {
    path: '/intel/RT20',
    name: 'RT20',
    component: RT20,
    meta: {
      title: 'RT-20 3D 混合仪 '
    }
  }, {
    path: '/intel/metal',
    name: 'Metal',
    component: Metal,
    meta: {
      title: 'Mini系列金属浴 '
    }
  }, {
    path: '/intel/MIX2500',
    name: 'MIX2500',
    component: MIX2500,
    meta: {
      title: 'MIX-2500迷你混合仪'
    }
  }, {
    path: '/intel/mini_centrifuge',
    name: 'MiniCentrifuge',
    component: MiniCentrifuge,
    meta: {
      title: '迷你离心机'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: {
      show:true,
      title: '分子试剂',
      content: {
        keywords: '合成生物学 基因  引物 测序',
        description: '擎科生物是一家CXO的公司'
      }
    },
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '搜索'
    }
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  }, {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  }, {
    path: '/reset',
    name: 'Reset',
    component: Reset,
    meta: {
      title: '重置密码'
    }
  }, {
    path: '/forget',
    name: 'Forget',
    component: Forget,
    meta: {
      title: '忘记密码'
    }
  }, {
    path: '/account_status',
    name: 'AccountStatus',
    component: AccountStatus,
    meta: {
      title: '账户状态'
    }
  }, {
    path: '/tec/order_sanger',
    name: 'OrderSanger',
    component: OrderSanger,
    meta: {
      title: 'Sanger测序发起取样',
      requireAuth: true
    }
  }, {
    path: '/tec/order_primer',
    name: 'OrderPrimer',
    component: OrderPrimer,
    meta: {
      title: '引物合成在线订购',
      scrollTop: true,
      requireAuth: true
    }
  }, {
    path: '/tec/primer_confirm',
    name: 'PrimerConfirm',
    component: PrimerConfirm,
    meta: {
      title: '引物合成订单确认',
      requireAuth: true
    }
  }, {
    path: '/tec/order_gene',
    name: 'OrderGene',
    component: OrderGene,
    meta: {
      title: '基因合成在线订购',
      requireAuth: true
    }
  }, {
    path: '/tec/gene_confirm',
    name: 'GeneConfirm',
    component: GeneConfirm,
    meta: {
      title: '基因合成订单确认',
      requireAuth: true
    }
  }, {
    path: '/tec/success_submit',
    name: 'SuccessSubmit',
    component: SuccessSubmit,
    meta: {
      title: '订单提交成功',
      requireAuth: true
    }
  }, {
    path: '/products/chart',
    name: 'ProductsChart',
    component: ProductsChart,
    meta: {
      title: '分子产品商城购物车',
      requireAuth: true
    }
  }, {
    path: '/products/chart_confirm',
    name: 'ProductsChartConfirm',
    component: ProductsChartConfirm,
    meta: {
      title: '擎科科邦邦商城订单确认',
      requireAuth: true
    }
  }, {
    path: '/user',
    name: 'User',
    component: User,
    meta: {
      title: '用户中心',
      requireAuth: true
    },
    children: [{
      path: '/user',
      name: 'UserIndex',
      component: UserIndex,
      meta: {
        title: '用户中心',
        requireAuth: true
      }
    }, {
      path: '/user/course',
      name: 'UserCourse',
      component: UserCourse,
      meta: {
        title: '课程组信息',
        requireAuth: true
      }
    }, {
      path: '/user/molecular',
      name: 'UserMolecular',
      component: UserMolecular,
      meta: {
        title: '擎科科邦邦商城订单',
        requireAuth: true
      }
    }, {
      path: '/user/sanger',
      name: 'UserSanger',
      component: UserSanger,
      meta: {
        title: 'Sanger测序订单',
        requireAuth: true
      }
    }, {
      path: '/user/fastNGS',
      name: 'fastNGS',
      component: fastNGS,
      meta: {
        title: 'Fast NGS订单',
        requireAuth: true
      }
    }, {
      path: '/user/sanger_record',
      name: 'UserSangerRecord',
      component: UserSangerRecord,
      meta: {
        title: '测序取样申请记录',
        requireAuth: true
      }
    }, {
      path: '/user/primer',
      name: 'UserPrimer',
      component: UserPrimer,
      meta: {
        title: '引物合成订单',
        requireAuth: true
      }
    }, {
      path: '/user/gene',
      name: 'UserGene',
      component: UserGene,
      meta: {
        title: '基因合成订单',
        requireAuth: true
      }
    }, {
      path: '/user/project',
      name: 'UserProject',
      component: UserProject,
      meta: {
        title: '项目订单',
        requireAuth: true
      }
    }, {
      path: '/user/mall',
      name: 'UserMall',
      component: UserMall,
      meta: {
        title: '积分商城',
        requireAuth: true
      }
    }, {
      path: '/user/integral_get',
      name: 'UserIntegralGet',
      component: UserIntegralGet,
      meta: {
        title: '积分获取记录',
        requireAuth: true
      }
    }, {
      path: '/user/integral_exchange',
      name: 'UserIntegralExchange',
      component: UserIntegralExchange,
      meta: {
        title: '积分兑换记录',
        requireAuth: true
      }
    }, {
      path: '/user/Collection',
      name: 'UserCollection',
      component: UserCollection,
      meta: {
        title: '商品收藏',
        requireAuth: true
      }
    }, {
      path: '/user/comment',
      name: 'UserComment',
      component: UserComment,
      meta: {
        title: '商品评论',
        requireAuth: true
      }
    }, {
      path: '/user/consult',
      name: 'UserConsult',
      component: UserConsult,
      meta: {
        title: '商品咨询',
        requireAuth: true
      }
    }, {
      path: '/user/arrivalNotice',
      name: 'arrivalNotice',
      component: arrivalNotice,
      meta: {
        title: '到货通知',
        requireAuth: true
      }
    }, {
        path: '/user/My_Coupons',
        name: 'My_Coupons',
        component: mycoupon,
        meta: {
          title: '我的优惠券',
          requireAuth: true
        }
      }, {
        path: '/user/Binding_Coupons',
        name: 'Binding_Coupons',
        component: bind,
        meta: {
          title: '绑定优惠券',
          requireAuth: true
        }
      },
    ]
  }, {
    path: '/user/product/details',
    name: 'UserProductDetail',
    component: UserProductDetail,
    meta: {
      title: '商品详情',
      requireAuth: true
    }
  }, {
    path: '/user/order_intergal',
    name: 'OrderIntergal',
    component: OrderIntergal,
    meta: {
      title: '积分兑换订单确认',
      requireAuth: true
    }
  }, {
    path: '/user/project_details',
    name: 'UserProjectDetails',
    component: UserProjectDetails,
    meta: {
      title: '项目订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/sanger_details',
    name: 'UserSangerDetails',
    component: UserSangerDetails,
    meta: {
      title: 'Sanger测序订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/fastNGS_details',
    name: 'fastNGSDetails',
    component: fastNGSDetails,
    meta: {
      title: 'fastNGS订单详情',
      requireAuth: true
    }
  },  
  {
    path: '/user/molecular_details',
    name: 'UserMolecularDetails',
    component: UserMolecularDetails,
    meta: {
      title: '分子订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/sanger_search',
    name: 'UserSangerSearch',
    component: UserSangerSearch,
    meta: {
      title: 'Sanger测序反应结果综合查询',
      requireAuth: true
    }
  }, {
    path: '/user/primer_details',
    name: 'UserPrimerDetails',
    component: UserPrimerDetails,
    meta: {
      title: '引物合成订单详情',
      requireAuth: true
    }
  }, {
    path: '/user/gene_details',
    name: 'UserGeneDetails',
    component: UserGeneDetails,
    meta: {
      title: '基因合成订单详情',
      requireAuth: true
    },
  },
  {
    path: '/share/member-auth',
    name: 'MemberAuth',
    component: MemberAuth,
    meta: {
      title: '客户授权',
      isShare: true
    },
  },
  {
    path: '/share/confirm-order',
    name: 'ConfirmOrder',
    component: ConfirmOrder,
    meta: {
      title: '订单详情',
      isShare: true,
    },
  },
  {
    path: '/share/confirm-popup',
    name: 'ConfirmPopup',
    component: ConfirmPopup,
    meta: {
      title: '确认',
      isShare: true
    },
  },
  // {
  //   path: '/user/primer_search',
  //   name: 'UserPrimerSearch',
  //   component: UserPrimerSearch,
  //   meta: {
  //     title: '引物合成反应结果综合查询',
  //     requireAuth: true
  //   }
  // },
  ...mobileRoutes
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    console.info(to)
    if (!to.meta.scrollTop) {
      return savedPosition;
    } else {
      return {x: 0, y: 0}
    }
  }
})

router.beforeEach((to, from, next) => {
  if((to.path != '/molecular-reagent' && !to.path.includes('/summary/')) || (to.name=='SummaryAbout' && from.name=="Index")){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  setTitle.title(to.meta.title)
  // 加入权限判断
  const userInfo = baseMethods.getLocalObj('userInfo')
  // if (to.matched.some(r => r.meta.requireAuth)) {
    var url = decodeURIComponent(window.location.search)
    //token缓存存在
    if (userInfo && userInfo.token && url.indexOf('sign')>-1) {
      const sign = baseMethods.getLocalStr('url')
      //比较的sign相同
      if(sign && sign === url) {
        next()
        //比较的sign不相同
      }else {
        console.log("比较的sign不相同")
        localStorage.clear()
        localStorage.removeItem('userInfo')
        Loading.service();
        Axios.get(`/web/user/customer-users/login/shop${url}`).then(async res => {
          if(res.data.token) {
            await baseMethods.setLocalObj('userInfo', res.data)
            baseMethods.setLocalStr('url',url)
            await store.dispatch('memberInfo')
            await store.dispatch('courseInfo')
            loginShopDelete(url.split("=")[1])
            let loadingInstance = Loading.service();
            loadingInstance.close();
            next()
          }else {
            Loading.service().close();
            next()
          }
        })
      }
      // token缓存不存在
    } else if(url.indexOf('sign')>-1){
      if (to.meta.isMobile) {
        // router.replace('/mobile/login')
      } else {
        Loading.service();
        //请求token
        Axios.get(`/web/user/customer-users/login/shop${url}`).then(async res => {
          if(res.data.token) {
            await baseMethods.setLocalObj('userInfo', res.data)
            baseMethods.setLocalStr('url',url)
            await store.dispatch('memberInfo')
            await store.dispatch('courseInfo')
            loginShopDelete(url.split("=")[1])
            let loadingInstance = Loading.service();
            loadingInstance.close();
            next()
          }else {
            Loading.service().close();
            next()
          }
        })
      }
    }else {
      next()
    }
})

router.afterEach((to, from) => {
  if(baseMethods.getLocalObj('memberInfo')) {
    store.dispatch('updateAgreementAction')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js